export default "__VITE_ASSET__lymV5anH__"